import { UploadFileInfo } from '@progress/kendo-react-upload';
import { fileTypeFromBuffer } from 'file-type';
import mime from 'mime';
import { toast } from 'react-toastify';

export interface unProcessedFiles {
  fileName: string;
  errorMessage: string;
  file?: UploadFileInfo;
}
export interface PreRequiredCheck {
  processed: UploadFileInfo[];
  unProcessed: unProcessedFiles[];
}

export interface ProcessedFilesState {
  processedFiles: UploadFileInfo[];
  preRequiredCheck: PreRequiredCheck;
}

export const allowedOcrFileExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
export const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.gif', '.bmp', '.png'];

export const S3FileValidations = async (
  affectedFiles: UploadFileInfo[],
  uploadPdfOnly: boolean
): Promise<ProcessedFilesState> => {
  const processedFiles: UploadFileInfo[] = [];
  const preRequiredCheck: PreRequiredCheck = {
    processed: [],
    unProcessed: [],
  };
  try {
    for (let i = 0; i < affectedFiles.length; i++) {
      const file = affectedFiles[i];
      let ext = file.extension?.toLocaleLowerCase() || '';
      const isPDF = ext === '.pdf';
      const isBelow5MB = typeof file.size === 'number' ? file.size <= 5 * 1024 * 1024 : true;
      const rawFile = file.getRawFile?.() as File;
      const fileType = await getFileTypeFromContent(rawFile);
      const mimeType = mime.getType(ext);
      const isValidExtension = fileType
        ? allowedExtensions.includes('.' + fileType.ext) && mimeType === fileType.mime
        : false;

      if (uploadPdfOnly && !isPDF) {
        preRequiredCheck.unProcessed.push({
          fileName: file.name,
          errorMessage: 'File format is not supported or does not match the extension.',
          file,
        });
      } else if (!isBelow5MB) {
        preRequiredCheck.unProcessed.push({
          fileName: file.name,
          errorMessage: 'File size is above 5 MB.',
          file,
        });
      } else if (!isValidExtension) {
        preRequiredCheck.unProcessed.push({
          fileName: file.name,
          errorMessage: 'File format is not supported.',
          file,
        });
      } else {
        processedFiles.push(file);
        preRequiredCheck.processed.push(file);
      }
    }
  } catch (error) {
    toast.error('Something went wrong');
    console.error(error);
  }

  return {
    processedFiles,
    preRequiredCheck,
  };
};

export const getFileTypeFromContent = async (file: File) => {
  if (file) {
    const buffer = await file.arrayBuffer();
    const fileType = await fileTypeFromBuffer(buffer);
    return fileType;
  }
};
